// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__3xUt5","inputWrap":"styles_inputWrap__iTCq5","input":"styles_input__2UuJx"};